// 2 weeks in seconds
export const PAYMENT_REMINDER_OVERDUE_SECONDS = 60 * 60 * 24 * 14;